const pluralizeCarModel = (make: string, model: string): string => {
  const specialCases: Record<string, string> = {
    'Nissan Kicks': 'Nissan Kicks',
    'Tesla Model S': 'Tesla Model Ses'
  };

  const fullName = `${make} ${model}`;

  if (specialCases[fullName]) {
    return specialCases[fullName];
  }

  const pluralize = (name: string): string => {
    if (/\d$/.test(name)) {
      return `${name}s`;
    }
    if (/[sxz]$/i.test(name) || /ch$/i.test(name) || /sh$/i.test(name)) {
      return `${name}es`;
    }
    if (/y$/i.test(name)) {
      const letterBeforeY = name.charAt(name.length - 2).toLowerCase();
      if (['a', 'e', 'i', 'o', 'u'].includes(letterBeforeY)) {
        return `${name}s`;
      }
      return `${name.slice(0, -1)}ies`;
    }
    return `${name}s`;
  };

  const modelParts = model.split(' ');
  const pluralizedModelParts = modelParts.map((part, index) => {
    if (index === modelParts.length - 1) {
      return pluralize(part);
    }
    return part;
  });

  const pluralizedModel = pluralizedModelParts.join(' ');

  return `${make} ${pluralizedModel}`;
};

export default pluralizeCarModel;
